import { computed as n } from "vue";
import { useMediaQuery as u } from "./design-system.es125.js";
function d(e) {
  const {
    width: r,
    breakpoint: t,
    query: i,
    exact: a
  } = e;
  if (i)
    return i;
  if (t) {
    if (a)
      switch (t) {
        case "extra-small":
          return "(max-width: 749px)";
        case "small":
          return "(min-width: 750px) and (max-width: 949px)";
        case "medium":
          return "(min-width: 950px) and (max-width: 1199px)";
        case "large":
          return "(min-width: 1200px) and (max-width: 1349px)";
        case "extra-large":
          return "(min-width: 1350px)";
        default:
          return "";
      }
    switch (t) {
      case "small":
        return "(min-width: 750px)";
      case "medium":
        return "(min-width: 950px)";
      case "large":
        return "(min-width: 1200px)";
      case "extra-large":
        return "(min-width: 1350px)";
      default:
        return "";
    }
  }
  return `(min-width: ${r}px)`;
}
function s(e) {
  const r = n(() => d(e));
  return u(r);
}
export {
  s as default
};
//# sourceMappingURL=design-system.es25.js.map
